"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactInspector = _interopRequireDefault(require("react-inspector"));

var _core = require("@emotion/core");

var _components = require("@storybook/components");

var _style = require("./style");

var ActionLogger = (0, _core.withCSSContext)(function (_ref, _ref2) {
  var actions = _ref.actions,
      onClear = _ref.onClear;
  var theme = _ref2.theme;
  return _react.default.createElement(_style.Wrapper, null, _react.default.createElement(_style.Actions, null, actions.map(function (action) {
    return _react.default.createElement(_style.Action, {
      key: action.id
    }, _react.default.createElement(_style.Countwrap, null, action.count > 1 && _react.default.createElement(_style.Counter, null, action.count)), _react.default.createElement(_style.InspectorContainer, null, _react.default.createElement(_reactInspector.default, {
      theme: theme.addonActionsTheme || 'chromeLight',
      sortObjectKeys: true,
      showNonenumerable: false,
      name: action.data.name,
      data: action.data.args || action.data
    })));
  })), _react.default.createElement(_components.ActionBar, null, _react.default.createElement(_components.ActionButton, {
    onClick: onClear
  }, "CLEAR")));
});
ActionLogger.propTypes = {
  onClear: _propTypes.default.func.isRequired,
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    count: _propTypes.default.node,
    data: _propTypes.default.shape({
      name: _propTypes.default.node.isRequired,
      args: _propTypes.default.any
    })
  })).isRequired
};
var _default = ActionLogger;
exports.default = _default;